// @ts-nocheck
/**
 * CSRD API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * The operation condition of the waterDischarge entry
 */
export type OperationCondition = 'NOC' | 'OTNOC' | 'INC';

export const OperationCondition = {
    NOC: 'NOC' as OperationCondition,
    OTNOC: 'OTNOC' as OperationCondition,
    INC: 'INC' as OperationCondition
};

